// Groups rows by a dimension column and aggregates a measure column.
// Returns an array of { group, value, rows } — one entry per unique group value.

const AGGREGATIONS = ["sum", "average", "count", "maximum", "minimum"];

export function groupBy(data, dimension, measure, aggregation = "sum") {

  if (!Array.isArray(data) || !data.length) {
    return [];
  }

  if (!dimension) {
    throw new Error("groupBy requires a dimension column.");
  }

  if (!AGGREGATIONS.includes(aggregation)) {
    aggregation = "sum";
  }

  const groups = {};

  for (const row of data) {

    const key = row[dimension] ?? "Unknown";

    if (!groups[key]) {
      groups[key] = [];
    }

    groups[key].push(row);
  }

  const results = [];

  for (const key of Object.keys(groups)) {

    const rows = groups[key];

    // count aggregation doesn't need a numeric measure
    if (aggregation === "count") {
      results.push({ group: key, value: rows.length, rows: rows.length });
      continue;
    }

    const values = rows
      .map(r => Number(r[measure]))
      .filter(v => !isNaN(v));

    let value = null;

    if (values.length) {

      switch (aggregation) {

        case "sum":
          value = values.reduce((a, b) => a + b, 0);
          break;

        case "average":
          value = values.reduce((a, b) => a + b, 0) / values.length;
          break;

        case "maximum":
          value = Math.max(...values);
          break;

        case "minimum":
          value = Math.min(...values);
          break;

        default:
          value = values.reduce((a, b) => a + b, 0);
      }
    }

    results.push({ group: key, value, rows: rows.length });
  }

  return results;
}
